import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { withStyles } from '@material-ui/core/styles'
import {
  AppBar,
  Toolbar,
  Drawer,
  Hidden,
  IconButton,
  List,
  ListItem,
  SvgIcon,
  Typography,
} from '@material-ui/core'
import { mdiClose, mdiMenu } from '@mdi/js'

import CONFIG from '../config'
import Link from './controls/Link'
import LinkButton from './controls/LinkButton'
import LoginLogout from './authentication/LoginLogout'
import Logo from '../../assets/images/logo/b_badge_stroked_dark.png'
import Logotype from '../../assets/images/logo/blok_logotype@2x.png'
import { withTracking } from './Tracking'

class Layout extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
  }

  static styles = (theme) => ({
    root: {
      width: '100%',
    },
    nav: {
      backgroundColor: 'white',
      padding: 5,
      color: '#252525',
      '@media print': {
        display: 'none',
      },
    },
    logoWrapper: {
      marginRight: 100,
      marginTop: 5,
    },
    logo: {
      height: 50,
    },
    logotype: {
      height: 50,
    },
    navLinks: {
      minWidth: 0,
      fontSize: 16,
      fontWeight: 500,
      lineHeight: 1.25,
      letterSpacing: -0.1,
      textTransform: 'none',
    },
    loginLogout: {
      textTransform: 'none',
      marginLeft: 'auto',
    },
    body: {
      position: 'relative',
      display: 'flex',
      width: '100%',
      height: '100%',
    },
    content: {
      width: '100%',
      background: '#f3f3f6',
      height: 'calc(100% - 100px)',
      minHeight: 'calc(100vh - 68px)',
      [theme.breakpoints.up('xs')]: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(2) + 66,
      },
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(3) + 66,
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
        paddingTop: theme.spacing(3) + 66,
      },
    },
    footer: {
      position: 'absolute',
      left: 0,
      width: '100%',
      padding: theme.spacing(3),
      backgroundColor: '#29363d',
      color: theme.palette.primary.contrastText,
      textAlign: 'center',
    },
    footerText: {
      color: theme.palette.primary.contrastText,
    },
    right: {
      marginLeft: 'auto',
    },
  })

  state = {
    mobileOpen: false,
  }

  handleDrawerToggle = () => {
    this.setState(
      (prevState) => ({
        mobileOpen: !prevState.mobileOpen,
      }),
    )
  }

  headerLinks = () => ([
    { title: 'Overview', link: `${CONFIG.blokable.marketingBaseUrl}/overview` },
    { title: 'Our Solution', link: `${CONFIG.blokable.marketingBaseUrl}/solution` },
    { title: 'The Team', link: `${CONFIG.blokable.marketingBaseUrl}/team` },
    { title: 'Get Involved', link: `${CONFIG.blokable.marketingBaseUrl}/getinvolved` },
  ])

  render() {
    const { classes, children } = this.props
    return (
      <div className={classes.root}>
        {/* Nav */}
        <AppBar className={classes.nav}>
          <Toolbar>
            <Link to={CONFIG.blokable.marketingBaseUrl} className={classes.logoWrapper}>
              <img src={Logo} alt="Blokable" className={classes.logo} />
              <img src={Logotype} alt="Blokable" className={classes.logotype} />
            </Link>
            <Hidden smDown>
              {this.headerLinks().map(({ title, link }, i) => (
                <LinkButton className={classes.navLinks} color="inherit" to={link} key={title}>
                  0{i + 1}<br />
                  {title}
                </LinkButton>
              ))}
              <LoginLogout className={classes.loginLogout} />
            </Hidden>
            <Hidden implementation="css" mdUp className={classes.right}>
              <IconButton color="inherit" aria-label="Menu" onClick={this.handleDrawerToggle}>
                <SvgIcon>
                  <path d={mdiMenu} />
                </SvgIcon>
              </IconButton>
            </Hidden>
          </Toolbar>
        </AppBar>
        <Drawer anchor="top" open={this.state.mobileOpen} onClose={this.handleDrawerToggle}>
          <List component="nav" className={classes.nav} dense>
            <ListItem>
              <Link to={CONFIG.blokable.marketingBaseUrl} className={classes.logoWrapper}>
                <img src={Logo} alt="Blokable" className={classes.logo} />
                <img src={Logotype} alt="Blokable" className={classes.logotype} />
              </Link>
              <IconButton color="inherit" aria-label="Menu" onClick={this.handleDrawerToggle} className={classes.right}>
                <SvgIcon>
                  <path d={mdiClose} />
                </SvgIcon>
              </IconButton>
            </ListItem>
            {this.headerLinks().map(({ title, link }, i) => (
              <ListItem key={title}>
                <LinkButton className={classes.navLinks} color="inherit" to={link} key={title}>
                  0{i + 1}.{title}
                </LinkButton>
              </ListItem>
            ))}
            <ListItem>
              <LoginLogout onLogout={this.handleDrawerToggle} />
            </ListItem>
          </List>
        </Drawer>
        <div className={classes.body}>
          {/* Left menu */}


          {/* Body */}
          <main className={classes.content}>
            {children}
          </main>
        </div>

        {/* Footer */}
        <footer className={classes.footer}>
          <Typography className={classes.footerText}>
            Copyright &copy; {moment().year()} Blokable&reg; Inc. All rights reserved. &nbsp;
            <Link className={classes.footerText} to={`${CONFIG.blokable.marketingBaseUrl}/privacy`}>
              Privacy Policy
            </Link>
          </Typography>
        </footer>
      </div>
    )
  }
}

export default withStyles(Layout.styles)(withTracking(Layout))
